export const environments = ['ProdEnv', 'OnbEnv', 'PTLand'];
